import Separator from './Separator';

export default Separator;



// WEBPACK FOOTER //
// ./src/components/Separator/index.ts